import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-setup-induction-question',
  templateUrl: './edit-setup-induction-question.component.html',
  styleUrls: ['./edit-setup-induction-question.component.css']
})
export class EditSetupInductionQuestionComponent implements OnInit {

  constructor(
    public dialogRef:MatDialogRef<EditSetupInductionQuestionComponent>,
  ) { }

  ngOnInit() {
  }
  DialogClose(){
    this.dialogRef.close(false)
  }
}
